/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

const swing = (progress) => {
  return 0.5 - Math.cos(progress * Math.PI) / 2;
};
const animate = (options) => {
  const start = new Date();
  const id = setInterval(function () {
    const timePassed = new Date() - start;
    let progress = timePassed / options.duration;
    if (progress > 1) {
      progress = 1;
    }
    options.progress = progress;
    const delta = options.delta(progress);
    options.step(delta);
    if (progress == 1) {
      clearInterval(id);
      options.complete();
    }
  }, options.delay || 10);
};
export const fadeOut = (element, options) => {
  const to = 1;
  animate({
    duration: options.duration,
    delta: function (progress) {
      progress = this.progress;
      return swing(progress);
    },
    complete: options.complete,
    step: function (delta) {
      element.style.opacity = to - delta;
    },
  });
};
export const fadeIn = (element, options) => {
  const to = 0;
  animate({
    duration: options.duration,
    delta: function (progress) {
      progress = this.progress;
      return swing(progress);
    },
    complete: options.complete,
    step: function (delta) {
      element.style.opacity = to + delta;
    },
  });
};
